export default {
  name: 'Article list section - 12',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Category listing section',
    introtext: '',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 2","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 3","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 4","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--secondary-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'inherit',
    'article-title-color': 'var(--text-dark-color)',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h4',
    'article-introtext-color': 'var(--text-dark-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'center',
    'article-columns': '2',
    'content-box': '1',
    'content-box-wrap': 'item',
    'content-box-color': 'var(--background-color)',
    'content-box-padding': '30px',
    'content-box-opacity': '0.15',
    'content-box-elevation': '8',
    'content-box-border': '1',
    'content-box-border-color': 'inherit',
    'content-box-rounded': '1'
  },
  advanced: {}
}
